import { useContext, useEffect, useLayoutEffect, useState } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';
import { media } from '../../../dataSets/media';
import { getStorageImage } from '../../../firebase/firebase_functions';

export default function HomeCarousel() {
    const {primary_color, currentWebsite} = useContext(AppContext);
    const [place, setPlace] = useState(0);
    const [imgUrl,setImgUrl] = useState(media.webingoLogo);
    const [images, setImages] = useState([]);

    useLayoutEffect(()=>{
        const fetchImages=async()=>{
            try{
                const advs = currentWebsite?.settings?.advertisments || [];
                const urls = await Promise.all(
                    advs.map((adv)=> getStorageImage(adv))
                )
                setImages(urls);
                if(urls.length > 0){
                    setImgUrl(urls[0]);
                }
            }
            catch(err){
                console.error("couldnt fetch spinner images: ", err)
            }
        }
        fetchImages();
    },[])
    useEffect(()=>{
        if(images.length === 0) return;
        const spin = setInterval(() => {
            setPlace((prevPlace)=>{return (prevPlace+1) % images.length});
        }, 8000);
        return ()=>clearInterval(spin);
    },[images])
    useEffect(()=>{
        if(images.length > 0){
            setImgUrl(images[place])
        }
    },[place, images])
    return (
        <img className='homePage_adv' style={{border:`0.5px solid ${primary_color}`}} src={imgUrl}alt='advertisment_carousel'></img>
    )
}
